import { signalStore } from '@ngrx/signals';
import { withDocumentReferenceMethods } from '../core/document-reference.store';
import { NdaTemplateDocumentReferenceService } from './nda-template-document-reference.service';

export const NdaTemplateDocumentReferenceStore = signalStore(
  { providedIn: 'root' },
  withDocumentReferenceMethods(NdaTemplateDocumentReferenceService)
);
